
      import { initializeAdvertising } from '/src/lib/advertisingConsent.ts';
      initializeAdvertising();
    